import { render, staticRenderFns } from "./ProfileUpdateForm.vue?vue&type=template&id=346a8872&scoped=true&"
import script from "./ProfileUpdateForm.vue?vue&type=script&lang=js&"
export * from "./ProfileUpdateForm.vue?vue&type=script&lang=js&"
import style0 from "./ProfileUpdateForm.vue?vue&type=style&index=0&id=346a8872&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346a8872",
  null
  
)

export default component.exports